import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ModelNameText = styled(Typography)`
  color: ${({ theme }) => theme.palette.white['06']};
  white-space: nowrap;
  width: 250px;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
`;

export const ChartContainer = styled(Box)`
  width: 100%;
  direction: row;
  justify-content: center;
  gap: 2;
  margin-top: 2;
`;
